import ApiResponseV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2";
import GenericCrudServiceV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudServiceV2";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";
import AssignationPause from "../models/AssignationPause";

class AssignationPauseService extends GenericCrudServiceV2<AssignationPause> {
  readonly path: string;

  constructor(path: string) {
    super(path);
    this.path = path;
  }

  findByAssignation(assignationExternalId: string): Promise<ApiResponseV2<AssignationPause[]>> {
    return HttpClientV2.get(`${this.basePath}/by-assignation?assignationExternalId=${assignationExternalId}`);
  }

  createPause(payload: AssignationPause): Promise<ApiResponseV2<AssignationPause>> {
    return HttpClientV2.post(`${this.basePath}`, payload);
  }

  deletePause(externalId: string): Promise<ApiResponseV2<AssignationPause>> {
    return HttpClientV2.delete(`${this.basePath}/${externalId}`);
  }

  getPausedDays(assignationExternalId: string, year: number, month: number): Promise<ApiResponseV2<Date[]>> {
    return HttpClientV2.get(`${this.basePath}/paused-days?assignationExternalId=${assignationExternalId}&year=${year}&month=${month}`);
  }
}

export default new AssignationPauseService("/ensolvers-ops/assignation-pause");
